import { IFRAME_TOP, IFRAME_WIDTH, SDK_DOMAIN } from '../../constants';

export const payLayer = `
    <div id="pay_layer" name="pay_layer" style="position:absolute;z-index:16777270;top:0;left:0;margin-top:0px;margin-left:0px;">
      <iframe id="iframe" name="iframe" style="width:${IFRAME_WIDTH}px;height:100%;top:${IFRAME_TOP}px; position:absolute; z-index:16777271; background:white;" frameborder="0" scrolling="auto"></iframe>
    </div>
  `;

export const iframeHead = `
    <meta charset="utf-8">
    <link rel="stylesheet" type="text/css" href="${SDK_DOMAIN}/css/index.css">
    <link rel="stylesheet" type="text/css" href="https://cdn.jsdelivr.net/gh/moonspam/NanumSquare@2.0/nanumsquare.css">
  `;
// <link rel="stylesheet" type="text/css" href="/build/css/index.css"></link>

export const iframeBody = `
    <header class="container-fluid"></header>
    <div id="layer-wrapper" class="container-fluid"></div>
    <footer class="container-fluid"></footer>
  `;
